<template>
  <div v-if="loading" class="placeholder-loading">
    <div class="head">
      <div class="subtitle">
        <slot name="subtitle">{{ info.createdAt | formatDate }}</slot>
      </div>

      <div class="title">
        <slot name="title">{{ title || '图片管理器' }}</slot>
      </div>

      <div class="control">
        <i class="el-icon-close" @click="close"></i>
      </div>
    </div>

    <div class="content">
      <div v-if="loading" class="loading-icon">
        <i class="el-icon-loading"></i>
      </div>
      <div class="err-msg">{{ msg }}</div>
    </div>
  </div>

  <camera
    v-else-if="isCamera"
    :id="id"
    :prev="prev"
    :next="next"
    :info="info"
    :is-rotate="isRotate90"
    :title="title"
    :subtitle="info.createdAt | formatDate"
    @on-load="onImgLoad"
    @go="getData"
  >
    <el-button
      plain
      slot="tools"
      :disabled="!(insects && insects.length)"
      @click="switchRecognize"
    >
      {{ showInsects ? '关闭识别' : '显示识别' }}
    </el-button>

    <div v-if="showInsects" class="model-insects" slot="mask">
      <div
        class="model-insect"
        v-for="item in insects"
        :key="item.id"
        :class="{ [`category-${item.categoryId}`]: true }"
        :style="getStyle(item)"
      >
        <div class="model-insect__name">{{ item.category }}</div>
      </div>
    </div>
  </camera>
  <scanner
    v-else
    :title="title"
    :subtitle="info.createdAt | formatDate"
    :src="info.src"
    :prev="prev"
    :next="next"
    :insects="insects"
    @on-load="onImgLoad"
    @go="getData"
  >
  </scanner>
</template>

<script>
import Camera from '@/components/ImgManager/model'
import Scanner from '@/components/InsectManager/model'
import { getInfo } from '@/service/telemetry'
import sleep from '@/utlis/sleep'

export default {
  name: 'ModalPic',
  components: { Camera, Scanner },
  props: {
    id: Number,
    query: Object
  },
  data() {
    return {
      loading: false,
      isCamera: false,
      isOrig: true, // 是否使用原图
      showInsects: true, // 是否显示识别
      isRotate90: false, // 缩略图是否旋转了 90 度
      info: { src: '', id: '-', device: '-' },
      insects: [],
      next: null, // 下一页
      prev: null, // 上一页
      msg: ''
    }
  },
  computed: {
    title() {
      return `${this.info.id} | ${this.info.device}`
    }
  },
  mounted() {
    // 按 Esc 键退出
    window.addEventListener('keyup', this.keyListener)
    this.$nextTick(() => this.getData(this.id))
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyListener)
  },
  methods: {
    close() {
      setTimeout(() => {
        if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el)
      }, 200)
    },
    keyListener(evt) {
      switch (evt.keyCode) {
        case 27:
          this.close() // 按键 ESC
          break
      }
    },
    async getData(id) {
      this.loading = true
      try {
        const { data } = await getInfo(id, this.query)

        const {
          id: imgId,
          storePath: src,
          tempPath: thumb,
          createdAt,
          device
        } = data.picture
        this.info = { id: imgId, src, thumb, createdAt, device }
        this.prev = this.query.limit === 1 ? null : data.prev
        this.next = this.query.limit === 1 ? null : data.next
        this.insects = data.insects.sort((a, b) => a.categoryId - b.categoryId)

        await Promise.all([this.loadImg(src), sleep(0.5)])
        this.loading = false
      } catch {
        // this.$message.error('图片加载失败')
        this.msg = '图片加载失败'
      }
    },
    loadImg(src) {
      return new Promise((res, rej) => {
        let img = new Image()
        img.src = src
        img.onload = () => {
          this.isRotate90 = img.height > img.width
          this.isCamera = img.width * img.height < 35000000
          res()
        }
        img.onerror = err => {
          rej(err)
        }
      })
    },
    onImgLoad(e) {
      this.isRotate90 = e.target.naturalHeight > e.target.naturalWidth
      this.isCamera = e.target.naturalHeight * e.target.naturalWidth < 35000000
    },
    switchRecognize() {
      this.showInsects = !this.showInsects
    },
    getStyle(item) {
      return {
        width: `${(item.tailPositionX - item.headPositionX) * 100}%`,
        height: `${(item.tailPositionY - item.headPositionY) * 100}%`,
        left: `${item.headPositionX * 100}%`,
        top: `${item.headPositionY * 100}%`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.placeholder-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 104;
  background-color: rgba(10, 10, 10, 0.7);
  color: #fff;
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 60px);
    .loading-icon {
      z-index: 3;
      position: absolute;
      width: 4rem;
      height: 4rem;
      font-size: 2rem;
      color: #fff;
      background-color: transparent;
      border-width: 2px;
    }
  }
  .head {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 0 40px;
    background-color: rgb(10, 10, 10);
    z-index: 105;
    .title,
    .subtitle,
    .control {
      flex: 1;
      font-size: 1.5rem;
      color: #fff;
      line-height: 60px;
    }
    .title {
      text-align: center;
    }
    .control {
      color: #fff;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      i {
        cursor: pointer;
        line-height: 60px;
        font-size: 1.5rem;
        &:not(:first-child) {
          margin-left: 1rem;
        }
      }
    }
  }
  .loading-icon {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .err-msg {
    text-align: center;
    font-size: 1rem;
    color: red;
    margin-top: 4rem;
  }
}
</style>

<style media="screen">
.model-insects {
  user-select: none;
  pointer-events: none;
}
.model-insect {
  position: absolute;
  border: 2px solid rgb(64, 158, 255);
}
.model-insect__name {
  font-size: 14px;
  position: absolute;
  white-space: nowrap;
  top: -20px;
  left: -4px;
}
.category-1 {
  color: rgb(255, 99, 132);
  border-color: rgb(255, 99, 132);
}
.category-2 {
  color: rgb(54, 162, 235);
  border-color: rgb(54, 162, 235);
}
.category-3 {
  color: rgb(255, 206, 86);
  border-color: rgb(255, 206, 86);
}
.category-4 {
  color: rgb(65, 184, 131);
  border-color: rgb(65, 184, 131);
}
.category-5 {
  color: rgb(204, 101, 254);
  border-color: rgb(204, 101, 254);
}
.category-6 {
  color: rgb(189, 162, 154);
  border-color: rgb(189, 162, 154);
}
</style>
